import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents BlogList.
 * @author kkum
 */import React, { Component } from 'react';
import styled from 'styled-components';
import BlogListTile from './BlogListTile';
import Heading from '../../atoms/Heading';
import Select from '../../atoms/Select';
import { blogLabels } from '../../../constants/labels/en';
import { siteConstants } from '../../../constants/globalConstants';
import analyticsConstants from '../../../constants/analyticsConstants';
import styles from './BlogList.style';
import { routes } from '../../../constants/routes';
import { preparingURLSegment } from '../../../utils/urlUtilities';

// const slugify = require('url-slug');
import urlSlug from 'url-slug';

/**
 * Extracts a list of categories from the list of articles
 * @param {Array} blogArticles List of article records
 * @returns {Array<string>} list of category names
 */
var extractCategoryList = function extractCategoryList(blogArticles) {
  var categories = blogArticles.map(function (a) {
    return a.blogCategory.categoryName;
  }).filter(function (category, idx, categories) {
    return categories.indexOf(category) === idx;
  }); // Remove dupe category names
  return categories;
};
/**
 * Comparse objects in an array and removes duplicates
 * @param {[*]} records Array of objects to deduplicate
 */
var removeDuplicates = function removeDuplicates(records) {
  // Remove duplicates
  var deduped = records.map(function (el) {
    return JSON.stringify(el);
  }).filter(function (el, idx, arr) {
    return arr.indexOf(el) === idx; // subsequent dupe entries will have indexes that don't match the first index
  }).map(function (el) {
    return JSON.parse(el);
  });
  return deduped;
};

/**
 * Counts the total number of paginated pages based on the provided category filter
 * @param {Array<Object>} blogArticles
 * @param {Number} limit
 * @param {Array} categoryFilter
 */
var BlogList = /*#__PURE__*/function (_Component) {
  _inherits(BlogList, _Component);
  var _super = _createSuper(BlogList);
  function BlogList(props) {
    var _this;
    _classCallCheck(this, BlogList);
    _this = _super.call(this, props);
    _this.state = {
      myValue: '',
      shownArticles: _this.props.blogArticleListData,
      filteredArticles: ''
    };
    return _this;
  }
  _createClass(BlogList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var urlParams = new URLSearchParams(window.location.search);
      var category = urlParams && urlParams.get('category');
      if (category) {
        var filteredArticles = this.state.shownArticles.filter(function (article) {
          return article.blogCategory.categoryName == category;
        });
        this.setState({
          filteredArticles: filteredArticles
        });
        this.setState({
          myValue: category
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        blogArticleListData = _this$props.blogArticleListData,
        imageRenditions = _this$props.imageRenditions,
        imageRenditionsFeatured = _this$props.imageRenditionsFeatured,
        pageUrl = _this$props.pageUrl;
      if (!blogArticleListData) {
        return null;
      }

      // Remove duplicates
      var filteredBlogData = removeDuplicates(blogArticleListData);
      // this.setState({shownArticles: filteredBlogData})
      // Calculate the total number of pages
      // const totalPages = countPagesInCategory(
      //   filteredBlogData,
      //   limit,
      //   categoryFilter
      // );

      // Build the categories list if not provided
      var categoryValues = this.props.categoryValues.length > 0 ? this.props.categoryValues : extractCategoryList(filteredBlogData);

      /**
       * Triggers the page navigation when a user changes the dropdown filter
       * @param {Event} event data from onChange event
       */
      var handleChange = function handleChange(event) {
        // Do nothing when there's no destination selected
        if (!event.target.value || event.target.value === '') {
          return false;
        }
        if (event.target.value == 'All') {
          _this2.setState({
            filteredArticles: _this2.state.shownArticles
          });
        } else {
          var filteredArticles = _this2.state.shownArticles.filter(function (article) {
            return article.blogCategory.categoryName == event.target.value;
          });
          _this2.setState({
            filteredArticles: filteredArticles
          });
        }
        _this2.setState({
          myValue: event.target.value
        });
      };
      var selectOptions = [blogLabels.ALL].concat(categoryValues).map(function (category, index) {
        return {
          label: category,
          dataAnalytics: {
            type: analyticsConstants.blogList.analyticsType.BLOG_FILTER,
            value: category,
            variation: ''
          },
          value: category
        };
      });
      return __jsx("div", {
        className: "nva-blog-list ".concat(className)
      }, __jsx("div", {
        className: "nva-blog-list__filter-container filter-container container"
      }, __jsx("div", {
        className: "nva-blog-list__filter filter"
      }, __jsx(Heading, {
        HeadingType: "h4",
        className: "nva-blog-list__filter-heading"
      }, blogLabels.CATEGORY, ":"), __jsx(Select, {
        className: "nva-blog-list__category-select",
        id: "category",
        options: selectOptions,
        name: "category",
        selectedOption: this.state.myValue ? this.state.myValue : blogLabels.ALL,
        onChange: handleChange,
        label: blogLabels.CATEGORY
      }))), __jsx("div", {
        className: "nva-blog-list__container blog-container"
      }, __jsx("div", {
        className: "container"
      }, __jsx("div", {
        className: "nva-blog-list__wrapper blog-wrapper"
      }, (this.state.filteredArticles || this.state.shownArticles).map(function (article, index) {
        var id = article.id,
          blogImage = article.blogImage,
          title = article.title,
          blogCategory = article.blogCategory,
          blogShortDescription = article.blogShortDescription,
          featured = article.featured,
          webpageBlog = article.webpageBlog,
          sys = article.sys;
        // Featured blog posts are only allowed on first page
        // and only for the first item on the page
        var isFeatured = featured;
        var renditions = isFeatured ? imageRenditionsFeatured : imageRenditions;
        var imageSource = blogImage && blogImage.image && blogImage.image.url;
        var shortDescription = blogShortDescription && blogShortDescription.json;
        var ctaUrl = article.url && "".concat(preparingURLSegment(pageUrl), "/").concat(preparingURLSegment(article.url)) || "".concat(preparingURLSegment(pageUrl), "/").concat(urlSlug(preparingURLSegment(article.title)));
        var tileWebpage = webpageBlog === null || webpageBlog === void 0 ? void 0 : webpageBlog.url;
        var blogTile = {
          slugId: sys === null || sys === void 0 ? void 0 : sys.id,
          imageClassName: 'nva-blog-list-tile__image img-container',
          imageSource: imageSource,
          imageAltText: blogImage.altText,
          imageTitle: blogImage.title || blogImage.altText,
          headingText: title,
          headingType: 'h3',
          headingClassName: 'nva-blog-list-tile__title',
          subHeadingText: blogCategory.categoryName,
          subHeadingType: 'h4',
          subHeadingClassName: 'nva-blog-list-tile__category',
          paraClassName: 'nva-blog-list-tile__description blog-description',
          descriptionType: siteConstants.RICH_TEXT,
          descriptionText: shortDescription,
          srcSetSetting: {
            imageRenditions: renditions
          },
          ctaURL: tileWebpage ? tileWebpage : ctaUrl.charAt(0) === '/' ? ctaUrl : "/".concat(ctaUrl),
          webpageBlogUrl: tileWebpage
        };
        return __jsx(BlogListTile, {
          featured: isFeatured,
          tile: blogTile,
          key: id
        });
      })))));
    }
  }]);
  return BlogList;
}(Component);
_defineProperty(BlogList, "defaultProps", {
  className: '',
  pageRoute: routes.blog,
  categoriesRoute: routes.blogCategories
});
BlogList.defaultProps = {
  className: '',
  categoryValues: [],
  limit: 10,
  pageRoute: routes.blog,
  currentPage: 1
};
export default styled(BlogList).withConfig({
  componentId: "sc-1tf6nlm-0"
})(["", ";"], styles);
export { BlogList as BlogListVanilla };